module.exports = __webpack_public_path__ + "img/step3.d16936a6.svg";